import React from "react";

export const SEV = {
  alta: { label: "Alta", cls: "border-rose-500/60 text-rose-200 bg-rose-500/15" },
  media: { label: "Media", cls: "border-amber-400/60 text-amber-200 bg-amber-500/15" },
  info: { label: "Informativa", cls: "border-sky-500/50 text-sky-200 bg-sky-500/10" },
};
export const fmtD = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");
export const fmtDT = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
export const bookingLink = (id) => `/prenotazioni?open=${id}`;

export function SevBadge({ sev, testid }) {
  const s = SEV[sev] || SEV.info;
  return <span data-testid={testid} className={`text-[10px] uppercase tracking-widest border rounded-full px-2 py-0.5 font-bold whitespace-nowrap ${s.cls}`}>{s.label}</span>;
}

export function Counter({ icon: Icon, label, value, hint, tone, testid, onClick }) {
  return (
    <button type="button" onClick={onClick} data-testid={testid}
      className="text-left rounded-2xl border border-amber-500/25 bg-gradient-to-b from-[#121009] to-[#070605] p-4 hover:border-amber-400/60 transition-colors">
      <div className="flex items-center gap-3">
        <Icon size={26} className={tone} />
        <div className="min-w-0">
          <div className={`font-display text-3xl leading-none ${tone}`}>{value}</div>
          <div className="text-xs text-slate-200 font-semibold mt-1 truncate">{label}</div>
          {hint && <div className="text-[10px] text-slate-500 truncate">{hint}</div>}
        </div>
      </div>
    </button>
  );
}

export function Panel({ title, icon: Icon, subtitle, right, children, testid }) {
  return (
    <section className="rounded-2xl border border-amber-500/25 bg-[#0A0907]" data-testid={testid}>
      <div className="flex flex-wrap items-center justify-between gap-3 px-4 sm:px-5 py-4 border-b border-amber-500/15">
        <div className="flex items-center gap-3 min-w-0">
          {Icon && <Icon size={22} className="text-amber-400 shrink-0" />}
          <div className="min-w-0">
            <h2 className="font-display text-lg text-white">{title}</h2>
            {subtitle && <p className="text-xs text-slate-500">{subtitle}</p>}
          </div>
        </div>
        {right}
      </div>
      <div className="p-3 sm:p-4">{children}</div>
    </section>
  );
}
